import React from 'react';
import {Col, Row} from "react-bootstrap";
import {TextField} from "@material-ui/core";

const PetsPage = () => {
    return (
        <div className="personal_affairs_container">
            <div className="info_header">
                <h3>Pets</h3>
            </div>
            {Array(2).fill(1).map((ele,index)=> (
                <div className="content mt-3 mb-5" key={index}>
                    {["Name:", "Type:", "Vet:", "Medication:"].map((title) => (
                        <Row className="mb-2 mx-0" key={title}>
                            <Col md="2">
                                {title}
                            </Col>
                            <Col md="10">
                                <TextField
                                    variant="filled"
                                    fullWidth={true}
                                    size="small"
                                />
                            </Col>
                        </Row>
                    ))}
                    <Row className="mb-2 mx-0">
                        <Col md="12">
                            Notes:
                        </Col>
                        <Col md="12">
                            <TextField
                                variant="filled"
                                fullWidth={true}
                                size="small"
                                multiline={true}
                                rows={6}
                            />
                        </Col>
                    </Row>
                </div>
            ))}
        </div>
    );
};

export default PetsPage;